export const LEGACY_UNSET_LOT_EXPIRATION = new Date("1970-01-01T00:00:00.000Z");

// A constant, never clock-derived: concurrent picker inserts dedupe only on identical dates.
export const PICKER_PLACEHOLDER_LOT_EXPIRATION = new Date(
  "2126-01-01T00:00:00.000Z",
);

const UNSET_LOT_EXPIRATION_MS = new Set([
  LEGACY_UNSET_LOT_EXPIRATION.getTime(),
  PICKER_PLACEHOLDER_LOT_EXPIRATION.getTime(),
]);

export function isUnsetLotExpiration(
  date: Date | string | null | undefined,
): boolean {
  if (!date) {
    return false;
  }
  const ms = (date instanceof Date ? date : new Date(date)).getTime();
  return UNSET_LOT_EXPIRATION_MS.has(ms);
}
